import { useComponentModal } from '@/share/components';
import MgOrgUserPickerView from './mg-org-user-picker-view.vue';

export const useMgOrgUserPicker = () => {
    const { openEditor } = useComponentModal();
    const showMgOrgUserPicker = async (title, props, modalProps) => {
        return openEditor(title, MgOrgUserPickerView, props, {
            fullscreen: false,
            showMaximize: false,
            showMinimize: false,
            width: '80%',
            height: '500px',
            ...modalProps,
        });
    };

    return {
        showMgOrgUserPicker,
    };
};
